import styled from 'styled-components';
import { Dialog, DialogContent, FormControl, InputLabel, TextField } from '@mui/material';

export const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    min-width: 400px;
  }
`;

export const StyledTextField = styled(TextField)`
  margin-bottom: 16px;
`;

export const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DialogHeader = styled.div`
  background-color: #f5f5f5;
  padding: 16px;
  display: flex;
  justify-content: center;
`;

export const DialogTitle = styled.h2`
  margin: 0;
`;

export const StyledFormControl = styled(FormControl)`
  margin: 0;
`;
export const StyledInputLabel = styled(InputLabel)`
  background-color: #fff;
`;

export const textoPequeno = styled.div`
  width: 90%;
  margin: 10px auto;
  text-align: center;
  color: #7d7d7d;
  font-size: 14px;
`;
